import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { AgencyDashboardPage } from '@/features/agency';
import { formatDocumentTitle } from '@/lib/document-title';

/** The list of every business the agency viewer can open, with New business. `/agency` itself is the Overview page. */
export const Route = createFileRoute('/_auth/agency/salons/')({
  component: AgencyBusinessesRoute,
});

function AgencyBusinessesRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Businesses')}</title>
      </Helmet>
      <AgencyDashboardPage />
    </>
  );
}
